import { tns } from 'tiny-slider/src/tiny-slider'
import { Component } from '../bootstrap/component'

export class Sliders extends Component {
  public onInit() {
    const sliders = document.querySelectorAll('[data-slider]');

    if (!sliders) {
      return;
    }

    sliders.forEach(slider => {
      this.crateSlider(slider as HTMLElement);
    });
  }

  public crateSlider(slider: HTMLElement) {
    const { id, items = 1 } = slider.dataset;

    let controlsContainer: HTMLElement;
    let container: HTMLElement;

    if (id) {
      // controlsContainer = document.querySelectorAll(`[data-slider-controls="${id}"]`)
      // container = document.querySelectorAll(`[data-slider="${id}"]`)
    } else {
      controlsContainer = slider.querySelector(`[data-slider-controls]`)
      container = slider.querySelector(`[data-slider-content]`)
    }

    tns({
      loop: true,
      container,
      mouseDrag: false,
      autoplay: false,
      // lazyload: true,
      controls: true,
      controlsContainer,
      autoHeight: true,
      nav: true,
      // @ts-ignore
      navPosition: 'bottom',
      center: false,
      autoWidth: false,
      edgePadding: 0,
      responsive: {
        0: {
          items: 1,
          slideBy: 1
        },
        1024: {
          items: Number(items),
          slideBy: Number(items),
        }
      }
    })
      .events.on('transitionEnd', (info) => {
        const activeElement = info.container.querySelector('.tns-slide-active') as HTMLElement;

        for (const prop in activeElement.dataset) {
          const element = document.getElementById(prop);

          if (element) {
            const value = activeElement.dataset[prop];
            element.innerHTML = value;
          }
        }
      });
  }
}